import api from "./base-api"

const helpCenterExportApi = api.injectEndpoints({
    endpoints: build => ({
        getHelpCenterExportNodes: build.query({
            query: (brand) => ({
                url: `v1/help-centers/${brand}/nodes`
            }),
            providesTags: ["helpCenterExportNodes"]
        }),
        getHelpCenterExportLocales: build.query({
            query: (brand) => ({
                url: `v1/help-centers/${brand}/nodes/locales`
            }),
            providesTags: ["helpCenterExportNodes"]
        }),
        loadHelpCenterExportNodesFromSpreadsheet: build.mutation({
            query: ({ brand, spreadsheetUrl }) => ({
                url: `v1/help-centers/${brand}/nodes/load`,
                method: "POST",
                body: spreadsheetUrl
            }),
            invalidatesTags: ["helpCenterExportNodes"]
        }),
        updateHelpCenterExportNode: build.mutation({
            query: ({ brand, nodeId, request }) => ({
                url: `v1/help-centers/${brand}/nodes/${nodeId}`,
                method: "PATCH",
                body: request
            }),
            invalidatesTags: ["helpCenterExportNodes"]
        }),
        deleteHelpCenterExportNodes: build.mutation({
            query: (brand) => ({
                url: `v1/help-centers/${brand}/nodes`,
                method: "DELETE"
            }),
            invalidatesTags: ["helpCenterExportNodes"]
        }),
        exportHelpCenterExportNodes: build.mutation({
            query: (brand) => ({
                url: `v1/help-centers/${brand}/nodes/export`,
                method: "POST"
            }),
            invalidatesTags: ["helpCenterExportNodes"]
        })
    })
})

export const {
    useGetHelpCenterExportNodesQuery,
    useGetHelpCenterExportLocalesQuery,
    useLoadHelpCenterExportNodesFromSpreadsheetMutation,
    useUpdateHelpCenterExportNodeMutation,
    useDeleteHelpCenterExportNodesMutation,
    useExportHelpCenterExportNodesMutation
} = helpCenterExportApi
